import includes from "lodash/includes"
import { getWindow } from "../getWindow"

const ssrWindow = getWindow()

/**
 * Checks if the current page is a local page.
 *
 * @function
 * @name isLocalPage
 * @returns {boolean} - Returns a boolean value indicating whether the current page is a local page or not.
 */
export const isLocalPage = includes(ssrWindow.location.pathname, "/local/")
